<template>
  <div class="securityCenterWrapper">
    <div class="tabs">
      <span
        :class="activeName == item.activeName ? 'on' : ''"
        v-for="(item, index) in tabsConfig"
        :key="index + item.code"
        @click="activeName = item.activeName"
        >{{ item.label }}</span
      >
    </div>
    <component :is="activeName" :phoneNo='basicUserInfo.phoneNo'></component>
  </div>
</template>
<script>
import safetyInfo from './components/safetyInfo.vue';
import changePwd from './components/changePwd.vue';
import changePayPwd from './components/changePayPwd.vue';
import { userOneselfInfo } from '@/api/userCenter';
export default {
  components: {
    safetyInfo,
    changePwd,
    changePayPwd,
  },
  data() {
    return {
      activeName: 'safetyInfo',
      tabsConfig: [
        {
          label: '安全信息',
          code: 1,
          activeName: 'safetyInfo',
        },
        {
          label: '修改密码',
          code: 2,
          activeName: 'changePwd',
        },
        {
          label: '修改支付密码',
          code: 3,
          activeName: 'changePayPwd',
        },
      ],
      basicUserInfo: {},
    };
  },
  methods: {
    init() {
      userOneselfInfo({
        userId: this.$store.state.user.user.userId,
      }).then((res) => {
        if (res) {
          this.basicUserInfo = res;
        }
      });
    },
  },
  created(){

    // if(this.$store.state.user.user.tenantId=='T0002'){
    //   this.tabsConfig= [
    //   {
    //       label: '安全信息',
    //       code: 1,
    //       activeName: 'safetyInfo',
    //     },
    //     {
    //       label: '修改密码',
    //       code: 2,
    //       activeName: 'changePwd',
    //     },
    //     {
    //       label: '修改支付密码',
    //       code: 3,
    //       activeName: 'changePayPwd',
    //     },
    //   ]
    // }else{
    //   this.tabsConfig= [
    //   {
    //       label: '安全信息',
    //       code: 1,
    //       activeName: 'safetyInfo',
    //     },
    //     {
    //       label: '修改密码',
    //       code: 2,
    //       activeName: 'changePwd',
    //     }
    //   ]
    // }
    this.init()
  }
};
</script>
<style lang="less" scoped>
.securityCenterWrapper {
  .tabs {
    height: 42px;
    border-bottom: 2px solid #e27c00;
    line-height: 42px;
    span {
      width: 100px;
      display: inline-block;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #55555a;
      height: 42px;
      cursor: pointer;
      &.on {
        background: rgba(226, 124, 0, 1);
        color: white;
      }
    }
  }
}
</style>